import store from "@state/store";

export default class Actions {
  startListeners() {
    this.lastInteract = new Date();
    const events = ["click", "keypress"];
    events.forEach(event => {
      window.addEventListener(event, this.handleListener);
    });
  }
  stopListeners() {
    const events = ["click", "keypress"];
    events.forEach(event => {
      window.removeEventListener(event, this.handleListener);
    });
  }
  handleListener() {
    clearInterval(window.intervalPopup);
    const $self = this;
    const lastInteract = new Date();
    const MINUTES_TO_SHOW = 5;

    function timeout() {
      const currentDate = new Date();
      const diff = currentDate - lastInteract;

      //
      // console.log("curent: ", currentDate.toISOString());
      // console.log("lastInteract", lastInteract.toISOString());
      // console.log("diff: ", diff);
      //

      if (
        diff > MINUTES_TO_SHOW * 60 * 1000 &&
        !store.getters["ui/getActivatedPopup"]
      ) {
        store.dispatch("ui/toogleActivatedPopup", true);
        store.dispatch("ui/toogleShowPopup", true);

        clearInterval(window.intervalPopup);
      }

      $self.lastInteract = new Date();
    }

    window.intervalPopup = setInterval(timeout, 2000);
  }
  handleExitToDocument() {
    // document.addEventListener("mouseleave", this.showPopup);
    window.addEventListener("blur", this.showPopup);
  }
  showPopup() {
    if (!store.getters["ui/getActivatedPopup"]) {
      store.dispatch("ui/toogleActivatedPopup", true);
      store.dispatch("ui/toogleShowPopup", true);
    }
  }
}
